import { Phone } from '@livecontrol/locale-us';
import { Matrix } from '@livecontrol/scheduler/components';
import React from 'react';

import S = Matrix.Stack;
import Card = S.Card;

interface Props {
  users: {
    id: string;
    name: string;
    email: string;
    phoneNumber: string;
    contactMethod: string;
    priority: string;
  }[];
}

export const UserStack = ({ users }: Props): React.ReactElement => (
  <S>
    {users.map(
      (user): React.ReactElement => (
        <Card key={user.id}>
          <Card.Body>
            <Card.Row label='Priority'>{user.priority}</Card.Row>
            <Card.Row label='Name'>{user.name}</Card.Row>
            <Card.Row label='Email'>{user.email}</Card.Row>
            <Card.Row label='Phone Number'>
              {Phone.normalize(user.phoneNumber)?.format({ parenthetical: true }) ??
                user.phoneNumber}
            </Card.Row>
            <Card.Row label='Preference'>{user.contactMethod}</Card.Row>
          </Card.Body>
        </Card>
      )
    )}
  </S>
);
